import { Box, Typography } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import { motion } from "framer-motion";
import { colors, alphaVar } from "../../../../ui/colors";

interface ViewModeToggleProps {
  isClientView: boolean;
  onToggle: (isClientView: boolean) => void;
}

export const ViewModeToggle = ({ isClientView, onToggle }: ViewModeToggleProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mb: 3,
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          bgcolor: alphaVar(colors.gray[100], 0.5),
          borderRadius: 2,
          p: 0.25,
          gap: 0.25,
        }}
      >
        <Box
          component={motion.div}
          initial={false}
          animate={{
            left: isClientView ? "calc(50% + 1px)" : "1px",
          }}
          transition={{
            type: "spring",
            stiffness: 500,
            damping: 30,
          }}
          sx={{
            position: "absolute",
            width: "calc(50% - 2px)",
            height: "calc(100% - 2px)",
            bgcolor: "var(--fx-surface-base, #FFFFFF)",
            borderRadius: 1.5,
            boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
            zIndex: 0,
          }}
        />
        <Box
          component="button"
          onClick={() => onToggle(false)}
          sx={{
            position: "relative",
            zIndex: 1,
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            px: 3.5,
            py: 0.75,
            border: "none",
            bgcolor: "transparent",
            cursor: "pointer",
            borderRadius: 1.5,
            transition: "all 0.2s ease",
            color: isClientView ? colors.gray[500] : colors.orange.base,
            fontWeight: isClientView ? 500 : 700,
            fontSize: "0.75rem",
            textTransform: "none",
            "&:hover": {
              color: isClientView ? colors.gray[600] : colors.orange.base,
            },
          }}
        >
          <EditIcon sx={{ fontSize: 16 }} />
          <Typography variant="body2" fontWeight="inherit" sx={{ fontSize: "0.75rem" }}>
            Editor
          </Typography>
        </Box>
        <Box
          component="button"
          onClick={() => onToggle(true)}
          sx={{
            position: "relative",
            zIndex: 1,
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            px: 3.5,
            py: 0.75,
            border: "none",
            bgcolor: "transparent",
            cursor: "pointer",
            borderRadius: 1.5,
            transition: "all 0.2s ease",
            color: isClientView ? colors.orange.base : colors.gray[500],
            fontWeight: isClientView ? 700 : 500,
            fontSize: "0.75rem",
            textTransform: "none",
            "&:hover": {
              color: isClientView ? colors.orange.base : colors.gray[600],
            },
          }}
        >
          <VisibilityIcon sx={{ fontSize: 16 }} />
          <Typography variant="body2" fontWeight="inherit" sx={{ fontSize: "0.75rem" }}>
            Client View
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
